import React from "react"

import "./leftworksize.scss"

/**
 * Button for change color (text/product)
 * @component
 * @param  {object} props
 * @param  {function} props.handler - handler button onclick function
 * @param  {string} props.color - value button onclick value
 * @param  {string} props.title - title button title
 * @param  {boolean} props.active - active button state
 *
 * @example
 * const handler = () => {}
 * const color = '#000'
 * const title = 'title'
 * const active = false
 *
 * return (
 *  <SizeBtn
 *    handler={handler}
 *    color={color}
 *    title={title}
 *    active={active}
 *  />
 * )
 */
const SizeBtn = props => {
  const {handler, size, title, active = false} = props
  return (
    <div className="leftWorkSizeSizeBtn_cont">
      <button
        className="leftWorkSizeSizeBtn"
        onClick={handler}
        style={{borderColor:active?"#3737ff" : "#B9B9B9", color:active?"#3737ff" : "#B9B9B9"}}
        data-value={title}
        data-size={size}
        // disabled={active}
      >
        {title}
        {/* {active && <img src="/assets/img/icons/selected_icn.svg" alt={title} />} */}
      </button>
      {/* <span>{title}</span> */}
    </div>
  )
}

export default SizeBtn
